import React from 'react';
import PropTypes from 'prop-types';

const YFSubmitButton = ({ className, test_id, label }) => {
    return <input test_id={test_id} className={className} type="submit" value={label} />;
};
YFSubmitButton.propTypes = {
    name: PropTypes.string.isRequired,
};
export default YFSubmitButton;
